export const inputHandler = (e, setState, inputName, propToSet = 'value') => {
    let value = e.target[propToSet]

    localStorage.setItem(inputName, value)

    setState((state) => {

        return {...state, [inputName]: value}
    })

}